import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Check, Forward } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import PresenceAvatar from "@/components/PresenceAvatar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForwardDialog({ message, conversations, onClose }) {
  const [picked, setPicked] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setPicked([]); }, [message]);

  const send = async () => {
    if (!picked.length) return;
    setBusy(true);
    try { await axios.post(`${API}/chat/messages/${message.message_id}/forward`, { conversation_ids: picked }); toast.success(`Encaminhada para ${picked.length} conversa(s)`); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao encaminhar"); }
    setBusy(false);
  };

  return (
    <Dialog open={!!message} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="forward-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Forward className="w-4 h-4" /> Encaminhar para...</DialogTitle></DialogHeader>
        <div className="max-h-80 overflow-y-auto space-y-1">
          {conversations.map(c => (
            <button key={c.conversation_id} type="button" data-testid={`forward-pick-${c.conversation_id}`}
              onClick={() => setPicked(p => p.includes(c.conversation_id) ? p.filter(x => x !== c.conversation_id) : [...p, c.conversation_id])}
              className={`w-full flex items-center gap-3 p-2 rounded-lg border text-left ${picked.includes(c.conversation_id) ? "border-primary bg-primary/5" : "border-transparent hover:bg-muted"}`}>
              <PresenceAvatar src={c.picture} name={c.name} online={c.online} className="w-9 h-9" />
              <span className="text-sm flex-1 truncate">{c.name}{c.type === "group" ? " · grupo" : ""}</span>
              {picked.includes(c.conversation_id) && <Check className="w-4 h-4 text-primary" />}
            </button>
          ))}
        </div>
        <Button className="w-full rounded-full" data-testid="forward-submit" disabled={!picked.length || busy} onClick={send}>Encaminhar ({picked.length})</Button>
      </DialogContent>
    </Dialog>
  );
}
